import Checkbox from './checkbox';
import CheckboxGroup from './checkbox-group';
var DefaultCheckbox = Checkbox;
DefaultCheckbox.Group = CheckboxGroup;
export default DefaultCheckbox;
//# sourceMappingURL=index.js.map